import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=6bd72074&scoped=true&"
import script from "./AddUserModal.vue?vue&type=script&lang=js&"
export * from "./AddUserModal.vue?vue&type=script&lang=js&"
import style0 from "./AddUserModal.vue?vue&type=style&index=0&id=6bd72074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd72074",
  null
  
)

export default component.exports